import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode:"history",
    routes: [
        {
            path: "/",
            name: "logisticsTracking",
            component: () => import("@/views/logisticsTracking/index.vue"),
            meta: { title: "trackful" },
        },
        {
            path: '/:tracking_number',
            name: "logisticsTrackingResult",
            component: () => import("@/views/logisticsTracking/trackingDisplay.vue"),
            meta: { title: "trackful result" },
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js